import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@1trading/react/components/ui/form';
import { RadioGroup, RadioGroupItem, RadioGroupItemCard } from '@1trading/react/components/ui/radio-group';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { BINARY_ANSWERS } from '@/constants/answers';
import type { InstitutionOwnershipOrDefaults } from '@/features/institution/ownership/schema';
import { createInstitutionPerson } from '@/features/institution/schemas/person';

const InstitutionOwnershipFieldsetHasOwners = () => {
  const form = useFormContext<InstitutionOwnershipOrDefaults>();
  const { t } = useTranslation();

  return (
    <FormField
      name="hasOwners"
      control={form.control}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{t('institutionDetails.ownership.hasOwners.title')}*</FormLabel>
          <FormControl>
            <RadioGroup
              defaultValue={field.value}
              variant="cards"
              aria-label={t('institutionDetails.ownership.hasOwners.title')}
              onValueChange={(value) => {
                const [firstUbo = createInstitutionPerson(), ...otherUbos] = form.getValues('ubos') ?? [];

                field.onChange(value);
                // Owners keep their details when the answer changes; a senior managing official is a single person with no ownership share
                form.setValue('ubos', value === 'YES' ? [firstUbo, ...otherUbos] : [{ ...firstUbo, ownershipPct: undefined }]);
              }}
            >
              {BINARY_ANSWERS.map((answer) => (
                <FormItem key={answer}>
                  <RadioGroupItemCard variant="outline">
                    <FormControl>
                      <RadioGroupItem value={answer} />
                    </FormControl>
                    <FormLabel contained>{t(`fundamentals.${answer.toLowerCase()}`)}</FormLabel>
                  </RadioGroupItemCard>
                </FormItem>
              ))}
            </RadioGroup>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
InstitutionOwnershipFieldsetHasOwners.displayName = 'InstitutionOwnershipFieldsetHasOwners';

export { InstitutionOwnershipFieldsetHasOwners };
